export const calendarRoute = {
  path: '/calendar',
  name: 'Calendar',
  meta: { hidePageHeader: true },
  component: () =>
    import('@/views/dashboard/widgets/calendar/ui/calendar_view.vue'),
};
